import React, { useState } from 'react';
import { createPortal } from 'react-dom';

const EMOJI_CATEGORIES: { label: string; icon: string; emojis: string[] }[] = [
  {
    label: 'פנים',
    icon: '😀',
    emojis: ['😀','😃','😄','😁','😆','😅','😂','🤣','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓'],
  },
  {
    label: 'ידיים',
    icon: '👍',
    emojis: ['👍','👎','👌','🤌','🤏','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','🖕','👇','☝️','👋','🤚','🖐️','✋','🖖','👏','🙌','🤝','🙏','✍️','💪','🦵','🦶'],
  },
  {
    label: 'אובייקטים',
    icon: '💡',
    emojis: ['💡','💰','💵','💳','📊','📈','📉','📝','📌','📎','📁','📂','📅','📆','📇','📧','✉️','📞','📱','💻','⌨️','🖥️','🖨️','⏰','⏱️','⏲️','🔔','🔕','🔑','🔒','🔓','🔗','⛓️'],
  },
  {
    label: 'סימנים',
    icon: '✅',
    emojis: ['✅','❌','❎','⚠️','🚫','❗','❓','⁉️','‼️','💯','🔥','⭐','🌟','💫','✨','💥','💢','💦','💨','🎯','🎉','🎊','🏆','🥇','🥈','🥉','🏅','🎖️'],
  },
  {
    label: 'לב',
    icon: '❤️',
    emojis: ['❤️','🧡','💛','💚','💙','💜','🖤','🤍','🤎','💔','❣️','💕','💞','💓','💗','💖','💘','💝','💟'],
  },
  {
    label: 'חץ',
    icon: '➡️',
    emojis: ['⬆️','↗️','➡️','↘️','⬇️','↙️','⬅️','↖️','↕️','↔️','↩️','↪️','⤴️','⤵️','🔃','🔄','🔙','🔚','🔛','🔜','🔝'],
  },
];

interface EmojiPickerProps {
  open: boolean;
  onClose: () => void;
  onSelect: (emoji: string) => void;
  anchorRect?: DOMRect | null;
}

export const EmojiPicker: React.FC<EmojiPickerProps> = ({ open, onClose, onSelect, anchorRect }) => {
  const [activeCategory, setActiveCategory] = useState(0);

  if (!open) return null;

  const style: React.CSSProperties = anchorRect
    ? {
        position: 'fixed',
        top: anchorRect.bottom + 8,
        left: Math.min(anchorRect.left, window.innerWidth - 340),
      }
    : { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' };

  return createPortal(
    <>
      <div className="tt-emoji-backdrop" onClick={onClose} />
      <div className="tt-emoji-picker" style={style} onClick={(e) => e.stopPropagation()}>
        <div className="tt-emoji-tabs">
          {EMOJI_CATEGORIES.map((cat, i) => (
            <button
              key={cat.label}
              type="button"
              className={[
                'tt-emoji-tab',
                activeCategory === i ? 'tt-emoji-tab-active' : '',
              ].join(' ')}
              onClick={() => setActiveCategory(i)}
              title={cat.label}
            >
              {cat.icon}
            </button>
          ))}
        </div>
        <div className="tt-emoji-grid">
          {EMOJI_CATEGORIES[activeCategory].emojis.map((emoji) => (
            <button
              key={emoji}
              type="button"
              className="tt-emoji-btn"
              onClick={() => { onSelect(emoji); onClose(); }}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    </>,
    document.body
  );
};
